import { gql } from "@apollo/client";
import { lensCompoundIdFragment } from "../../../lenses/api/fragments/lensCompoundIdFragment";

const affectedGroupsFragment = gql`
    fragment AffectedGroup on LenssourceAffectedGroupByLensSource {
        groupId
        groupName
        affectedNumLenses
        lenses {
            ...LensCompoundId
            iconUrl
        }
    }
`;

export const getAffectedGroups = gql`
    query getAffectedGroups($lensSourceId: String, $limit: Int, $cursor: String, $organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        getAffectedGroups(
            input: {
                organizationId: $organizationId
                limit: $limit
                lensSourceId: $lensSourceId
                lensLimit: 10
                cursor: $cursor
            }
        ) {
            affectedGroups {
                ...AffectedGroup
            }
            cursor
            hasMore
        }
    }
    ${lensCompoundIdFragment}
    ${affectedGroupsFragment}
`;

export const getCachedAffectedGroups = gql`
    query getCachedAffectedGroups {
        getAffectedGroups(input: { organizationId: null }) {
            affectedGroups {
                ...AffectedGroup
            }
            cursor
        }
    }
    ${lensCompoundIdFragment}
    ${affectedGroupsFragment}
`;
